export default class HMRLoadingView {
  static showMessage() {}

  static hide() {}
}
